import Form from '@/found/components/form';
import request from '@/found/utils/request';
import { BLACK_USER_ENDPOINTS } from '../actions';

export default {
  extends: Form,
  data() {
    const formConfig = this.formConfig || {};
    return {
      formFunctionCode: formConfig.formFunctionCode
        || (this.$route && this.$route.query && this.$route.query.formFunctionCode)
        || 'risk_black_user_form',
      buttonText: {
        submit: '保存',
        close: '关闭',
        submitAudit: '保存',
      },
    };
  },
  watch: {
    formConfig: {
      deep: true,
      handler(config) {
        this.$nextTick(() => this.syncFormData(config));
      },
    },
  },
  methods: {
    syncFormData(config = {}) {
      if (!this.fApi || typeof this.fApi.setValue !== 'function') return;

      if (config.code === 'edit') {
        this.setValue(config.row || {});
        return;
      }

      if (config.code === 'add') {
        if (typeof this.fApi.resetFields === 'function') this.fApi.resetFields();
        this.setValue({ enableStatus: '009' });
      }
    },

    formComplete() {
      this.syncFormData(this.formConfig);
    },

    submit(requestClient) {
      const client = requestClient && typeof requestClient.post === 'function'
        ? requestClient
        : request;
      const formData = this.getFormData();
      if (!formData) return Promise.resolve({ success: false, skipped: true });

      const code = this.formConfig && this.formConfig.code === 'edit' ? 'edit' : 'add';
      return client.post(BLACK_USER_ENDPOINTS[code], {
        ...formData,
        ...(code === 'edit' ? { id: this.formConfig.row && this.formConfig.row.id } : {}),
      }).then((res) => {
        if (res.success) {
          this.$message({ type: 'success', message: code === 'edit' ? '编辑成功' : '保存成功' });
          this.$emit('onClose');
          this.$emit('onGetList');
        }
        return res;
      });
    },
  },
};
